<template>
	<div>
		<!-- One curriculum (the common case): render it flat, no section chrome. -->
		<template v-if="goalGroups.length === 1">
			<GoalsDisplayGroup :group="goalGroups[0]" />
		</template>

		<!-- Goals from several curricula: same exclusive accordion the editable
		     GoalsField uses, so viewing and editing a plan look alike. -->
		<div v-else-if="goalGroups.length > 1" class="flex flex-col gap-2">
			<div
				v-for="group in goalGroups"
				:key="group.key"
				class="collapse collapse-arrow border border-base-200 rounded-box"
			>
				<input
					type="radio"
					:name="accordionName"
					:checked="group.key === openGroupKey"
					@change="openGroupKey = group.key"
				/>
				<div class="collapse-title font-semibold flex items-center gap-2">
					{{ group.curriculum.name || $t('Other') }}
					<div class="badge badge-sm badge-info">{{ countParentGoals(group.goals) }}</div>
				</div>
				<div class="collapse-content">
					<GoalsDisplayGroup :group="group" />
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Curriculum, CurriculumGoalGroup, countParentGoals } from "@/models/Curriculum.model";
import { Goal } from "@/models/Goal.model";
import GoalsDisplayGroup from "@/components/GoalsDisplayGroup.vue";

export default {

	components: {
		GoalsDisplayGroup,
	},

	props: {
		goals: {
			type: Array,
			default: () => [],
		},

		// The school's curriculum, which only affects section ordering (it leads).
		curriculum: {
			type: Curriculum,
			default: null,
		},
	},

	data() {
		return {
			// Open section, tracked by group key so it survives a goals change.
			openGroupKeyInternal: null as string | null,
			accordionName: 'goals-display-accordion-' + Math.floor(Math.random() * 999999),
		};
	},

	computed: {
		goalGroups(): CurriculumGoalGroup[] {
			// Grouping + ordering are shared with GoalsField; only the sort within a group
			// is ours — a read-only list reads best by path rather than by insertion order.
			return Curriculum.groupGoals(this.goals as Goal[], this.curriculum).map((group) => ({
				...group,
				goals: [...group.goals].sort(
					(a, b) => (a.fullPath || '').localeCompare(b.fullPath || '')
				),
			}));
		},

		openGroupKey: {
			get(): string | null {
				if (
					this.openGroupKeyInternal
					&& this.goalGroups.some((g: CurriculumGoalGroup) => g.key === this.openGroupKeyInternal)
				) {
					return this.openGroupKeyInternal;
				}
				return this.goalGroups[0]?.key ?? null;
			},
			set(value: string) {
				this.openGroupKeyInternal = value;
			},
		},
	},

	methods: {
		countParentGoals,
	},

};
</script>
